import PropTypes from "prop-types";
import "components/form/Radio/Radio.scss";

function Radio({ label, checked, group, onChange }) {
  return (
    <label className={ 'form-radio-container' }>
      { label }
      <input type={ 'radio' }
             name={ group }
             checked={ checked && 'checked' }
             onChange={ onChange }/>
      <span className="form-radio"/>
    </label>
  );
}

Radio.propTypes = {
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  group: PropTypes.string.isRequired
}

export default Radio;
